<template>
  <div class="container page-content">
    <h1>{{ $route.meta.title }}</h1>

    <div v-if="formData">
      <div v-if="formData.orderStatus === 5" style="color: red">
        此長照已取消 取消原因: {{ formData.cancelReason }}
      </div>
      <Timeline
        v-else
        :values="orderSteps"
        :currentStep="formData.orderStatus"
        style="margin-bottom: 50px"
      />

      <div v-if="formData.orderStatus === 5" class="text-center">
        <router-link :to="{ name: 'longTermOrderList' }">
          <el-button size="mini">取消</el-button>
        </router-link>
        <el-button type="danger" @click="deleteOrder()">刪除</el-button>
      </div>
      <div v-else class="text-right">
        <el-button
          v-if="formData.orderStatus === 4"
          type="danger"
          size="medium"
          @click="recoverStatus"
        >
          恢復待驗單狀態
        </el-button>
        <router-link
          :to="{ name: 'editLongTermOrderForm', params: { orderId } }"
        >
          <el-button type="primary" size="medium">編輯</el-button>
        </router-link>
        <el-button size="medium" @click="back">取消</el-button>
      </div>

      <div class="border-container">
        <div class="order-info-section">
          <div class="order-status-stamp">
            <i
              v-if="formData.orderStatus === 4"
              class="fa fa-check order-status-stamp__finished"
            ></i>
            <i
              v-if="formData.orderStatus === 5"
              class="fa fa-ban order-status-stamp__cancelled"
            ></i>
          </div>
          <h2 class="title"><span>乘客資訊</span></h2>
          <div class="table-responsive">
            <table class="table table-hover">
              <tbody>
                <tr>
                  <td>乘客</td>
                  <td>{{ formData.name }}</td>
                </tr>
                <tr>
                  <td>行政區</td>
                  <td>{{ formData.area }}</td>
                </tr>
                <tr>
                  <td>住家地址</td>
                  <td>{{ formData.address }}</td>
                </tr>
                <tr>
                  <td>聯絡人</td>
                  <td>{{ formData.contactPerson || '無' }}</td>
                </tr>
                <tr>
                  <td>住家電話</td>
                  <td>{{ formData.telephoneNumber }}</td>
                </tr>
                <tr>
                  <td>手機一</td>
                  <td>{{ formData.firstMobilePhoneNumber || '無' }}</td>
                </tr>
                <tr>
                  <td>手機二</td>
                  <td>
                    {{ formData.secondMobilePhoneNumber || '無' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="order-info-section">
          <h2 class="title"><span>即時資訊</span></h2>
          <div class="table-responsive">
            <table class="table table-hover">
              <tbody>
                <tr>
                  <td>本月剩餘補助</td>
                  <td>{{ formData.subsidyLastAmount || 0 }}</td>
                </tr>

                <tr>
                  <td>社區式剩餘次數</td>
                  <td>{{ formData.lastCommunityShuttleFrequency || 0 }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="order-info-section">
          <h2 class="title"><span>司機資訊</span></h2>
          <div class="table-responsive">
            <table class="table table-hover">
              <tbody>
                <tr>
                  <td>司機</td>
                  <td>
                    {{ (formData.driver && formData.driver.name) || '---' }}
                  </td>
                </tr>
                <tr>
                  <td>使用車牌</td>
                  <td>{{ formData.licenseNumber || '---' }}</td>
                </tr>
                <tr>
                  <td>聯絡電話一</td>
                  <td>{{ formData.driverFirstContactNumber || '---' }}</td>
                </tr>
                <tr>
                  <td>聯絡電話二</td>
                  <td>{{ formData.driverSecondContactNumber || '---' }}</td>
                </tr>
                <tr>
                  <td>車機編號</td>
                  <td>{{ formData.driverTaximeterNumber || '---' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="order-info-section">
          <h2 class="title"><span>乘車資訊</span></h2>
          <div class="table-responsive">
            <table class="table table-hover">
              <tbody>
                <tr>
                  <td>派單方式</td>
                  <td>
                    {{
                      defaultOption.deliveryMethodLookup[
                        formData.deliveryMethod
                      ]
                    }}
                  </td>
                </tr>

                <tr>
                  <td>預定上車時間</td>
                  <td>
                    {{
                      formData.estimateGetOnTime
                        ? $moment(formData.estimateGetOnTime).format(
                            'YYYY/MM/DD HH:mm',
                          )
                        : '---'
                    }}
                  </td>
                </tr>
                <tr>
                  <td>實際上車時間</td>
                  <td>
                    {{
                      formData.getOnTime
                        ? $moment(formData.getOnTime).format('YYYY/MM/DD HH:mm')
                        : '---'
                    }}
                  </td>
                </tr>

                <tr>
                  <td>實際下車時間</td>
                  <td>
                    {{
                      formData.getOffTime
                        ? $moment(formData.getOffTime).format(
                            'YYYY/MM/DD HH:mm',
                          )
                        : '---'
                    }}
                  </td>
                </tr>

                <tr>
                  <td>上車地址</td>
                  <td>{{ formData.onLocation || '---' }}</td>
                </tr>

                <tr>
                  <td>下車地址</td>
                  <td>{{ formData.offLocation || '---' }}</td>
                </tr>

                <tr>
                  <td>實際上車GPS</td>
                  <td>
                    {{
                      (formData.getOnGps && formData.getOnGps.join(', ')) ||
                      '---'
                    }}
                  </td>
                </tr>

                <tr>
                  <td>實際下車GPS</td>
                  <td>
                    {{
                      (formData.getOffGps && formData.getOffGps.join(', ')) ||
                      '---'
                    }}
                  </td>
                </tr>

                <tr>
                  <td>乘客數</td>
                  <td>{{ formData.seat ? `${formData.seat}人` : '無' }}</td>
                </tr>

                <tr>
                  <td>偏好服務</td>
                  <td>
                    {{
                      formData.serviceList
                        .map((s) => defaultOption.serviceLookup[s])
                        .join(', ') || '無'
                    }}
                  </td>
                </tr>

                <tr>
                  <td>客服備註</td>
                  <td>{{ formData.serviceNote || '無' }}</td>
                </tr>

                <tr>
                  <td>司機備註</td>
                  <td>{{ formData.driverNote || '無' }}</td>
                </tr>
                <br />
              </tbody>
            </table>
          </div>
        </div>

        <div class="order-info-section">
          <h2 class="title"><span>費用資訊</span></h2>
          <div class="table-responsive">
            <table class="table table-hover">
              <tbody>
                <tr>
                  <td>輔助方式</td>
                  <td>
                    {{
                      defaultOption.subsidyMethodLookup[formData.subsidyMethod]
                    }}
                  </td>
                </tr>

                <tr>
                  <td>區域類型</td>
                  <td>{{ defaultOption.areaTypeLookup[formData.areaType] }}</td>
                </tr>

                <tr>
                  <td>身份別</td>
                  <td>{{ defaultOption.userClassLookup[formData.class] }}</td>
                </tr>

                <tr>
                  <td>里程數</td>
                  <td>{{ formData.milage || 0 }}</td>
                </tr>

                <tr>
                  <td>自付比例</td>
                  <td>{{ formData.payForOwnselfProportion || 0 }}%</td>
                </tr>

                <tr>
                  <td>跳錶金額</td>
                  <td>NT {{ formData.metreFare || 0 }}</td>
                </tr>

                <tr>
                  <td>輔助金額</td>
                  <td>NT {{ formData.subsidyFare || 0 }}</td>
                </tr>

                <tr>
                  <td>實收金額</td>
                  <td>NT {{ formData.actualFare || 0 }}</td>
                </tr>

                <tr>
                  <td>驗證</td>
                  <td>
                    {{
                      defaultOption.verificationMethodLookup[
                        formData.verificationMethod
                      ]
                    }}
                    <br />
                    <img
                      v-if="formData.verificationPhoto"
                      :src="formData.verificationPhoto"
                      alt="驗證圖"
                      style="height: 250px"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defaultOption } from './defaultOption'
import longTermCareService from '@/API/longTermCareService'
import Timeline from './Timeline'
export default {
  components: { Timeline },
  data() {
    return {
      defaultOption,
      formData: null,
      orderSteps: [
        {
          value: 0,
          content: '找司機',
        },
        {
          value: 1,
          content: '待載客',
        },
        {
          value: 2,
          content: '載客中',
        },
        {
          value: 3,
          content: '待驗單',
        },
        {
          value: 4,
          content: '完成',
        },
      ],
    }
  },
  created() {
    this.fetchOrder()
  },
  computed: {
    orderId() {
      return this.$route.params && this.$route.params.orderId
    },
  },
  methods: {
    recoverStatus() {
      longTermCareService
        .updateOrderStatus(this.orderId, 3)
        .then((data) => {
          this.$message.success(data.message)
          this.fetchOrder()
          // this.$emit("reload");
        })
        .catch(({ data: { error }, message }) =>
          this.$message.error(message || error.message),
        )
    },
    fetchOrder() {
      const _reasonLookup = {
        乘客取消: 1,
        乘客爽約: 2,
      }

      longTermCareService
        .getOrderById(this.orderId)
        .then((raw) => {
          const formData = raw.result
          if (formData.cancelReason) formData.hasReason = 3
          if (_reasonLookup[formData.cancelReason])
            formData.hasReason = _reasonLookup[formData.cancelReason]

          this.$set(this, 'formData', {
            ...formData,
            service: formData.serviceList,
          })
        })
        .catch(({ data: { error } = {}, message }) =>
          this.$message.error(message || error.message),
        )
    },
    back() {
      setTimeout(() => this.$router.go(-1), 500)
    },
    deleteOrder() {
      longTermCareService
        .deleteOrder(this.orderId)
        .then(({ message }) => this.$message.success(message) && this.back())
        .catch(({ data: { error } = {} || message }) =>
          this.$message.error(message || error.message),
        )
    },
  },
}
</script>

<style scoped>
.page-content {
  max-width: 960px;
  margin: auto;
}

.order-status-stamp {
  position: absolute;
  right: 20px;
  top: 120px;
  font-size: 85px;
}

.order-status-stamp__cancelled {
  color: #d50000;
}

.order-status-stamp__finished {
  color: #67c23a;
}

.order-info-section {
  position: relative;
  margin-bottom: 30px;
}

.order-info-section .title {
  background: transparent;
  position: relative;
  text-align: center;
}
.order-info-section .title > span {
  display: inline;
  background: #fff;
  padding: 5px;
  margin: auto;
  z-index: 2;
}
.order-info-section .title::after {
  display: block;
  content: '';
  top: 50%;
  margin-top: -2px;
  width: 100%;
  position: absolute;
  border: 1px solid #e5e5e5;
  z-index: -1;
}

.table > tbody > tr > td {
  padding-top: 20px;
  padding-bottom: 5px;
  border-top: none;
  border-bottom: 1px solid #ddd;
}
.table > tbody > tr > td:first-child {
  text-align: right;
  width: 300px;
}

.border-container {
  border: 2px solid #ebeef5;
  padding: 5px 20px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/longTermCare/OrderDetail.vue